import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
const SearchPageBanners = () => {
  const { t } = useTranslation();
  const [banners, setBanners] = useState([]);
  useEffect(() => {
    fetch("/api/banners_api.php")
      .then((res) => res.json())
      .then((data) => {
        console.log("📦 Баннеры из базы:", data);
        setBanners(data);
      })
      .catch((err) => console.error("❌ Ошибка загрузки баннеров:", err));
  }, []);

  // Показываем данные для проверки
  if (!banners || banners.length === 0) {
    return (
      <div className="p-8 text-center text-gray-500">
        {t("bannersload")}
      </div>
    );
  }

 const sorted = [...banners].sort((a, b) => Number(a.position) - Number(b.position));
const banner1 = sorted.find((b) => Number(b.position) === 1);
const banner2 = sorted.find((b) => Number(b.position) === 2);
const banner3 = sorted.find((b) => Number(b.position) === 3);

  return (
    <div className="w-full bg-gray-50 flex justify-between gap-3 p-6 items-start max-md:flex-col">
      {/* Левый большой баннер */}
      {banner1 && (
        <a
          href={banner1.link_url}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-gray-200 shadow-2xl shadow-slate-400 mt-12 rounded-2xl w-[320px] h-[400px] max-sm:w-full bg-cover bg-center flex items-center justify-center"
          style={{ backgroundImage: `url(${banner1.image_url})` }}
        />
      )}

      {/* Правая колонка */}
      <div className="w-[400px] flex flex-col justify-start max-sm:p-6 max-sm:gap-3 gap-12">
        {banner2 && (
          <a
            href={banner2.link_url}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gray-200 w-full mt-12 rounded-2xl shadow-2xl shadow-slate-400  bg-cover bg-left h-[200px]  flex items-center justify-center"
            style={{ backgroundImage: `url(${banner2.image_url})` }}
          />
        )}
        {banner3 && (
          <a
            href={banner3.link_url}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gray-200 w-full rounded-2xl shadow-2xl shadow-slate-400  h-[200px] bg-cover bg-center  flex items-center justify-center"
            style={{ backgroundImage: `url(${banner3.image_url})` }}
          />
        )}
      </div>
    </div>
  );
};

export default SearchPageBanners;
